import AI_PROCESSING_RESPONSE from '@/entities/report/api/queries/aiProcessingResponse';
import { createClient } from '@/shared/api';
import type { AiProcessingQuery, AiProcessingQueryVariables } from '@/shared/api/generated/graphql';

export type AiProcessingResponse = {
  canSwitchTab: boolean;
  processingCmd: string;
};

/**
 * Reads the AI worker's processing state for a report request. Normalizes a null requestId to an empty string, runs the aiProcessing query, and returns canSwitchTab for the switchTab type or the pending processingCmd for anything else.
 *
 * @param requestId - Identifier of the AI processing request, or null.
 * @param type - Which facet to read; defaults to switchTab.
 * @returns A promise resolving to the tab-switch flag or the pending processing commands.
 */
const fetchAIProcessingStatus = async (requestId: string | null, type = 'switchTab') => {
  const client = await createClient();
  const requestIdString = requestId === null ? '' : requestId;
  const result = await client.query<AiProcessingQuery, AiProcessingQueryVariables>({
    query: AI_PROCESSING_RESPONSE,
    variables: { requestId: requestIdString, type },
  });
  const { data } = result;
  const { aiProcessing } = data;

  if (type === 'switchTab') return aiProcessing.canSwitchTab;

  return aiProcessing.processingCmd;
};

export default fetchAIProcessingStatus;
